import 'lightgallery';
import 'lg-thumbnail';



$(document).ready(function () {


$('.admin-ligth-gallery').lightGallery({
    selector: '.img-licznik',
    thumbnail: true
});

$('.galleries .row').lightGallery({
    selector: '.flex-something',
    thumbnail: true
});

$('.galeria_home').lightGallery({
    selector: '.once_image',
    thumbnail: false
});

$('.gal_zdjecia').lightGallery({
    selector: '.hand_lightgal',
    thumbnail: true
});

$('.gal_pow').lightGallery({
    selector: '.hand_pow',
    thumbnail: true
});

$('.gal_product').lightGallery({
    selector: '.gal_product_img',
    thumbnail: true
});

$('#app').lightGallery({
    selector: '.flex-something',
    thumbnail: false
});


$('.table__gallery--hidden').lightGallery({
    selector: '.hidden_hand',
    thumbnail: false
});
var colours = ['#fff'];
var $customEvents = $('.table__gallery--hidden');
$customEvents.lightGallery();
$customEvents.on('onBeforeSlide.lg', function(event, prevIndex, index){
    $('.lg-outer').css('background-color', colours[index])
});


$('.product__img__wrapper').lightGallery({
    selector: '.product__img__a',
    thumbnail: false
});

// $('.lista_products').lightGallery({
//     selector: '.product_one',
//     thumbnail: false
// });

$('.lupa_table').on('click', function() {
    console.log('asd');
    var id = $(this).data('id');
    $('.light_gal_'+id+' .hidden_hand').click();
})
})
